<div
  *ngIf="permissionTableHelperService.permissions$ | async as permissions; else loading"
  class="loading-indicator-wrapper"
>
  <miq-permission-table
    [id]="'id'"
    [title]="'Groups'"
    [selectionMode]="'multiple'"
    [headerColumns]="groupColumns"
    [tableRecords]="permissions.group"
    [propertySetId]="propertySetId"
    [hideCheckbox]="!haveAcessToPropertySet"
    [addTooltip]="!haveAcessToPropertySet ? 'Owner permission required to add/remove permissions' : ''"
    [isAddDisabled]="!haveAcessToPropertySet"
    (deleteEvent)="deletePermission($event)"
    (doneEvent)="savePermission($event)"
    (updateEvent)="updatePermission($event)"
  ></miq-permission-table>
  <!--- Users Table--->
  <miq-permission-table
    [id]="'id'"
    [title]="'Users'"
    [selectionMode]="'multiple'"
    [headerColumns]="userscolumns"
    [tableRecords]="permissions.user"
    [propertySetId]="propertySetId"
    [sortField]="'user_name'"
    [addTooltip]="addTooltip"
    [hideCheckbox]="!haveAcessToPropertySet"
    [addTooltip]="!haveAcessToPropertySet ? 'Owner permission required to add/remove permissions' : ''"
    [isAddDisabled]="!haveAcessToPropertySet"
    (deleteEvent)="deletePermission($event)"
    (doneEvent)="savePermission($event)"
    (updateEvent)="updatePermission($event)"
  ></miq-permission-table>
</div>
<ng-template #loading>
  <h1 class="fx--title">Loading...</h1>
</ng-template>
